import axios from 'axios';

const BASE_API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';

export const getOrganizationBySlug = async (slug) => {
  const response = await axios.get(`${BASE_API}/organizations/by-slug/${slug}`);
  return response.data;
};
